import React from 'react';
import { DialogActions, DialogContentText } from '@mui/material';
import { gatewaySpecificProps } from './PaymentSpecificGatewaySettings';

const PaymentGatewayRenderer = ({ mediosPago, buildCommonProps }) => {
  return (
    <DialogActions style={{ 
      display: 'flex',
      flexDirection: 'column',
      gap: '0px',
      alignItems: 'center',
      padding: '0px',
      width: '100%',
      boxSizing: 'border-box'
    }}>
      {mediosPago && mediosPago.length > 0 ? (
        mediosPago.map((medio) => (
          <div key={medio.nombre} style={{
            width: '100%',
            maxWidth: '300px',
            margin: '0 auto'
          }}>
            <payment-gateway
              {...buildCommonProps(medio.signature)}
              {...(gatewaySpecificProps[medio.nombre] || {})}
              gateway={medio.nombre}
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '4px'
              }}
            />
          </div>
        ))
      ) : (
        <DialogContentText style={{ padding: '16px', textAlign: 'center' }}>
          No hay opciones de pago disponibles.
        </DialogContentText>
      )}
    </DialogActions>
  );
};

export default PaymentGatewayRenderer;